
export type ExpandableEventDetail = {
    action: "open" | "close",
    identifier: string | null
};

export class ExpandableEvent extends CustomEvent<ExpandableEventDetail>
{
    public static readonly KEY = "toggle-expandable";

    public constructor(eventInitDict: CustomEventInit<ExpandableEventDetail>)
    {
        super(ExpandableEvent.KEY, eventInitDict);
    }
}
